export default __webpack_public_path__ + "static/media/total_invoice.da5d6b66.svg";